import * as React from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import UserCreationContext from "./UserCreationContext";

export default function NewUserSummary() {
    const {email, name, kundennummer,isOwner,accessibleFolders,userGroups,Mail_Ansprechpartner,Ansprechpartner} = React.useContext(UserCreationContext)

  return (
    <>
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <Typography variant="h5" component="div" sx={{ flexGrow: 1, }}>
            Zusammenfassung
        </Typography>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1,mt:2 }}>
            Einladung
        </Typography>
        <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
            E-Mail: {email}
        </Typography>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1,mt:2 }}>
            User Details
        </Typography>
        <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
            Name: {name}
        </Typography>
        <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
            Ist Eigentümer: {isOwner ? "Ja" : "Nein"}
        </Typography>
        {
            isOwner && (
                <>
            <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
            Kundenummer: {kundennummer}
        </Typography>
            <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
            Ansprechpartner: {Ansprechpartner}
        </Typography>
            <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
            Mail Ansprechpartner: {Mail_Ansprechpartner}
        </Typography>
                </>
            )
        }
        {
            isOwner && (
                <>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1,mt:2 }}>
            Freigegebene Ordner
        </Typography>
        {accessibleFolders.map((folder) =>
        <Typography key={folder.key} component="div" sx={{ flexGrow: 1,ml:2 }}>
             {folder.label}
        </Typography>
        )}
        {
            accessibleFolders.length == 0 && (
                <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
                    Keine Ordner freigegeben
                </Typography>
            )
        }
                </>
            )
        }
        {
            (!isOwner) && (
                <>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1,mt:2 }}>
            Usergruppen
        </Typography>
        {userGroups.map((ug) =>
        <Typography key={ug} component="div" sx={{ flexGrow: 1,ml:2 }}>
            {ug}
        </Typography>
        )}
        {
            userGroups.length == 0 && (
                <Typography  component="div" sx={{ flexGrow: 1,ml:2 }}>
                    Keine Usergruppen zugewiesen
                </Typography>
            )
        }
                </>
            )
        }

      </Box>
    </>
  );
}
